/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateCompositionsDetailMutationRequest, CreateCompositionsDetailMutationResponse } from "../models/CreateCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createCompositionsDetail } from "../axios/createCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createCompositionsDetailMutationKey = () => ["web-app-bff-api", { url: '/compositions' }] as const

export type CreateCompositionsDetailMutationKey = ReturnType<typeof createCompositionsDetailMutationKey>

export function createCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createCompositionsDetailMutationKey()
        return mutationOptions<CreateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {data: CreateCompositionsDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createCompositionsDetail(data, config)
          },
        })

}

/**
 * @summary Create a composition
 * {@link /compositions}
 */
export function useCreateCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {data: CreateCompositionsDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateCompositionsDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createCompositionsDetailMutationKey()

          const baseOptions = createCompositionsDetailMutationOptions(config) as UseMutationOptions<CreateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {data: CreateCompositionsDetailMutationRequest}, TContext>
          

          return useMutation<CreateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {data: CreateCompositionsDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {data: CreateCompositionsDetailMutationRequest}, TContext>
      
}